import React, { useMemo, useState } from 'react';

interface UserAvatarProps {
  name?: string | null;
  src?: string | null;
  className?: string;
  imgClassName?: string;
}

const getInitial = (name?: string | null) => {
  if (!name) return '?';
  const trimmed = name.trim();
  if (!trimmed) return '?';
  return trimmed[0].toUpperCase();
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  name,
  src,
  className = 'w-8 h-8',
  imgClassName = ''
}) => {
  const [imgError, setImgError] = useState(false);
  const initial = useMemo(() => getInitial(name), [name]);
  const showImage = Boolean(src) && !imgError;

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full bg-gray-200 text-gray-700 font-semibold overflow-hidden ${className}`}
      aria-label={name || 'User'}
    >
      {showImage ? (
        <img
          src={src as string}
          alt={name || 'User'}
          className={`w-full h-full object-cover ${imgClassName}`}
          onError={() => setImgError(true)}
        />
      ) : (
        <span className="text-sm">
          {initial}
        </span>
      )}
    </div>
  );
};
